// extracted by mini-css-extract-plugin
module.exports = {"PasswordReset":"PasswordReset_PasswordReset__poia7"};